import type { LocalSettings } from "@app/config/LocalSettings";
import localSettings from "@app/config/LocalSettings";
import Scope from "@app/types/dashboard/Scope";

export interface EmailReportingView {
  range: string;
  scope: Scope;
}

const isNumberOrUndefined = (value: unknown): value is number | undefined =>
  value === undefined || typeof value === "number";

class ReportingSettings {
  settings: LocalSettings;

  private readonly EMAIL_REPORTING_VIEW = "__EMAIL_REPORTING_VIEW__";

  constructor(settings: LocalSettings) {
    this.settings = settings;
  }

  getEmailReportingView = (): EmailReportingView | undefined => {
    const value = localStorage.getItem(this.EMAIL_REPORTING_VIEW);
    if (!value) {
      return undefined;
    }
    try {
      const parsed = JSON.parse(value);
      if (
        parsed &&
        typeof parsed.range === "string" &&
        parsed.scope &&
        typeof parsed.scope === "object" &&
        isNumberOrUndefined(parsed.scope.teamId) &&
        isNumberOrUndefined(parsed.scope.userId)
      ) {
        return { range: parsed.range, scope: parsed.scope };
      }
    } catch {
      return undefined;
    }
  };

  setEmailReportingView = (view: EmailReportingView) => {
    localStorage.setItem(this.EMAIL_REPORTING_VIEW, JSON.stringify(view));
  };

  clearEmailReportingView = () => {
    localStorage.removeItem(this.EMAIL_REPORTING_VIEW);
  };
}

const reportingSettings = new ReportingSettings(localSettings);

export default reportingSettings;
